// extracted by mini-css-extract-plugin
export default {"bottomFooter":"index_bottomFooter_OYho2","cooperation":"index_cooperation_ivwWa","footer":"index_footer_hDgpl"};